import React from 'react';
import { Check, Bot, Filter, ChevronDown, Trash2 } from 'lucide-react';
import PowerDialButton from '../../components/PowerDialButton.jsx';
import BulkActionsMenu from './BulkActionsMenu.jsx';

export default function LeadsBulkActionBar({
  selected,
  allMatching,
  clearSelection,
  orderedSelectedIds,
  leads,
  onOpenAiDial,
  bulkMenuOpen,
  setBulkMenuOpen,
  bulkAction,
  bulkAssignTextBot,
  setDispoToBotOpen,
  setAddToPipelineOpen,
  setTransferToLeadAssistOpen,
  aiBots,
  setBulkSmsOpen,
  setBulkEmailOpen,
  openCsvWizard,
  agents,
  dispositions,
  vendors,
  drips,
  campaigns,
  pipelines,
}) {
  if (selected.size === 0) return null;

  return (
    <div className="panel p-3 flex items-center justify-between gap-3 sticky top-2 z-20 border-civix-purple/40">
      <div className="flex items-center gap-2">
        <button
          onClick={clearSelection}
          className="w-6 h-6 rounded-sm bg-civix-purple flex items-center justify-center cursor-pointer"
        >
          <Check className="w-4 h-4 text-white" />
        </button>
        <span className="text-sm font-semibold">
          {selected.size.toLocaleString()} selected
          {allMatching && <span className="ml-1 text-civix-purpleSoft/80">(all matching filter)</span>}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <PowerDialButton
          leadIds={orderedSelectedIds}
          leads={leads.filter((l) => selected.has(l._id))}
        />
        <button
          onClick={onOpenAiDial}
          className="btn-secondary flex items-center gap-2 cursor-pointer"
          title="Launch an AI dialer campaign on the selected leads"
        >
          <Bot className="w-4 h-4" /> AI Dial Selected
        </button>
        <button
          onClick={() => {
            if (!window.confirm(`Delete ${selected.size.toLocaleString()} selected lead(s)? This cannot be undone.`)) return;
            bulkAction.mutate({ action: 'delete', payload: {} });
          }}
          disabled={bulkAction.isPending}
          className="btn-secondary flex items-center gap-2 cursor-pointer text-red-300 hover:text-red-200 disabled:opacity-50"
          title="Delete the selected leads"
          aria-label="Delete selected leads"
        >
          <Trash2 className="w-4 h-4" /> {bulkAction.isPending ? 'Deleting…' : 'Delete'}
        </button>
        <div className="relative">
          <button
            onClick={() => setBulkMenuOpen((o) => !o)}
            className="btn-primary flex items-center gap-2 cursor-pointer"
          >
            <Filter className="w-4 h-4" /> Bulk actions
            <ChevronDown className={`w-3 h-3 transition ${bulkMenuOpen ? 'rotate-180' : ''}`} />
          </button>
          {bulkMenuOpen && (
            <BulkActionsMenu
              onClose={() => setBulkMenuOpen(false)}
              onAction={(action, payload) => bulkAction.mutate({ action, payload })}
              onAssignTextBot={(botId) => bulkAssignTextBot.mutate({ botId })}
              onDispositionToBot={() => { setBulkMenuOpen(false); setDispoToBotOpen(true); }}
              onAddToPipeline={() => { setBulkMenuOpen(false); setAddToPipelineOpen(true); }}
              onTransferToLeadAssist={() => { setBulkMenuOpen(false); setTransferToLeadAssistOpen(true); }}
              aiBots={aiBots}
              onBulkSms={() => { setBulkMenuOpen(false); setBulkSmsOpen(true); }}
              onBulkEmail={() => { setBulkMenuOpen(false); setBulkEmailOpen(true); }}
              onBulkExport={() => {
                setBulkMenuOpen(false);
                openCsvWizard(new Set(selected));
              }}
              agents={agents}
              dispositions={dispositions}
              vendors={vendors}
              drips={drips}
              campaigns={campaigns}
              pipelines={pipelines}
            />
          )}
        </div>
      </div>
    </div>
  );
}
